import type { HTMLAttributes } from 'react';
import { cn } from '../../lib/utils';

type Variant = 'neutral' | 'success' | 'warning' | 'danger' | 'info';

const styles: Record<Variant, string> = {
  neutral: 'text-haze bg-surface-2 border-hairline',
  success: 'text-success bg-success-dim border-transparent',
  warning: 'text-warning bg-warning-dim border-transparent',
  danger: 'text-danger bg-danger-dim border-transparent',
  info: 'text-info bg-info-dim border-transparent',
};

interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  variant?: Variant;
  dot?: boolean;
}

/** Small status pill. Optional leading dot for connection/lifecycle states. */
export function Badge({
  variant = 'neutral',
  dot = false,
  className,
  children,
  ...props
}: BadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5',
        'font-mono text-[0.7rem] font-medium',
        styles[variant],
        className,
      )}
      {...props}
    >
      {dot && <span className="h-1.5 w-1.5 rounded-full bg-current" />}
      {children}
    </span>
  );
}
